<template>
  <div class="force-password-page">
    <BContainer fluid>
      <BRow class="min-vh-100 align-items-center justify-content-center px-2 py-4">
        <BCol
          cols="12"
          md="10"
          lg="8"
          xl="7"
        >
          <BCard class="shadow-lg border-0 rounded-xl overflow-hidden">
            <div class="force-password-header">
              <h2 class="mb-2">
                Set Your New Password
              </h2>
              <p class="mb-0">
                Please update your default password before accessing student features.
              </p>
            </div>

            <div class="p-3 p-md-4 bg-white">
              <StudentChangePassword />
            </div>
          </BCard>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StudentChangePassword from '@/views/student/account-settings/ChangePassword.vue'

export default {
  name: 'VStudentForcePasswordChange',

  components: {
    StudentChangePassword
  },

  middleware: ['auth', 'student'],

  metaInfo: () => ({
    title: 'Force Password Change'
  }),

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  mounted () {
    if (this.currentUser && !this.currentUser.must_change_password) {
      this.$router.replace({ name: 'student.dashboard' })
    }
  }
}
</script>

<style scoped>
.force-password-page {
  min-height: 100vh;
  background: radial-gradient(circle at top right, #dcfce7 0%, #f0fdf4 45%, #ecfeff 100%);
}

.force-password-header {
  background: linear-gradient(135deg, #047857 0%, #065f46 100%);
  color: #ecfdf5;
  padding: 1.2rem 1.4rem;
}

.force-password-header h2 {
  font-size: 1.35rem;
  font-weight: 700;
}

.force-password-header p {
  font-size: 0.92rem;
  opacity: 0.94;
}

@media (max-width: 767px) {
  .force-password-header {
    padding: 1rem 1.05rem;
  }

  .force-password-header h2 {
    font-size: 1.15rem;
  }
}
</style>
